export enum EnumContractsRepeat {
    Always = 'Sempre',
    No_repeat = 'Não repepetir'
}

export const contractsRepeat = Object.entries(EnumContractsRepeat).map(([key, value]) => ({ value: key, label: value }));
